import React, { Component } from "react";
import { connect } from "react-redux";
import HireButton from "../../Common/Hire";
import SendEmail from "../../Common/SendEmail";
import QuotationPrice from "../../Common/Quotation/Price";
import PriceLines from "../../Common/Quotation/PriceLines"
import Loader from '../../Common/Loader';
import SelectedAnswers from './SelectedAnswers';
import ErrorMessage from '../../Common/ErrorMessage';
import { vehicles, client } from "../../../operations";
import { 
  setInnerPagesList,
  setStepInnerPage,
  decreaseStepByOne,
  setVehiclesValue,
  goBackAuto,
  setOptionalQuotationValue
} from '../../../actions';

class Quotation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: true,
    };

    this.priceContent = this.priceContent.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { stepInnerPage, setInnerPagesList } = this.props;
    if(!stepInnerPage || stepInnerPage.name !== 'sendEmail')
      setInnerPagesList([
        { name: 'quotation', back: '' },
        { name: 'sendEmail', back: '', backButton: false }
      ]);
  }

  priceContent() {

    const { hasAssistance, onVehiclesValueChange, economic } = this.props;

    const iconCheck = <span className="Price-icon-check" />;
    const iconCross = <span className="Price-icon-cross" />;

    const content = [
      {label:'Auxilio mecánico en Territorio Nacional, Mercosur y Chile', 
                                             value:(hasAssistance ? iconCheck : iconCross)},
      {label:'Responsibilidad Civil',        value:'USD 400.000'},
      {label:'Pérdida Total por Incendio',   value:iconCheck},
      {label:'Pérdida Parcial por Incendio', value:iconCheck},
      {label:'Gastos pérdida Total',         value:iconCross},
      {label:'Reposición 0km',               value:'1 año'},
      {label:'Pérdida Total por Hurto',      value:iconCheck},
    ];

    const contentEconomic = [  // TODO nico
      {label:'Responsibilidad Civil',        value:'USD 400.000'},
      {label:'Pérdida Total por Incendio',   value:iconCheck},
      {label:'Pérdida Parcial por Incendio', value:iconCheck},
      {label:'Gastos pérdida Total',         value:iconCross},
      {label:'Reposición 0km',               value:'1 año'},
      {label:'Pérdida Total por Hurto',      value:iconCheck},
    ];

    return(
      <div>
        {!economic && 
          <div className="Price-withAssistance">
            <div>
              <input type="radio" name="withAssistance" id="withAssistance-true"
                onChange={() => { onVehiclesValueChange('hasAssistance', true)}}
                value="true" hidden checked={hasAssistance}
              />
              <label htmlFor="withAssistance-true">
                <span className={`Price-input-radio ${hasAssistance && 'Price-input-radio--checked'}`}></span>
                <span>Con auxilio mecánico</span>
              </label>
            </div>
            <div>
              <input type="radio" name="withAssistance" id="withAssistance-false"
                onChange={() => { onVehiclesValueChange('hasAssistance', false)}}
                value="false" hidden checked={!hasAssistance}
              />
              <label htmlFor="withAssistance-false">
                <span className={`Price-input-radio ${!hasAssistance && 'Price-input-radio--checked'}`}></span>
                <span>Sin auxilio mecánico</span>
              </label>
            </div>
          </div>
        }
        <PriceLines content={economic ? contentEconomic : content}/>
      </div>
    );
  }

  render() {

    const { 
      stepInnerPage, loading, 
      quoteId, hasAssistance,
      sendQuoteByEmail, quoter, getQuotation,
      errorMessage, setStepInnerPage, economic
    } = this.props;

    switch (stepInnerPage.name) {
      case 'quotation':
        return (<div>
                  { loading ? 
                      <Loader /> :
                      quoteId > 0 ?
                        <div>
                          <SelectedAnswers {...this.props}/>
                          <div>
                            {!economic && 
                              <QuotationPrice
                                header='Cobertura Standard'
                                currency='$U'
                                middle=''
                                isOptional={!hasAssistance}
                                footerFeesOn={false}
                                priceContent={this.priceContent} 
                              />
                            }
                            {economic && 
                              <QuotationPrice
                                header='Cobertura Económica'
                                currency='$U'
                                middle=''
                                isOptional={!hasAssistance}
                                footerFeesOn={false}
                                priceContent={this.priceContent} 
                              />
                            }
                            <HireButton onThinkClick={() => {
                              setStepInnerPage('sendEmail');
                              sendQuoteByEmail(quoter);
                            }}/>
                          </div>
                        </div> : errorMessage ?
                        <ErrorMessage 
                          errorText='Tuvimos un inconveniente con la cotización'
                          tryAgainText= 'Volver a cotizar'
                          tryAgainAction={getQuotation}
                        /> : null
                  }
                </div>);
      case 'sendEmail':
        return <SendEmail />;
    };
    return <div/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    errorMessage: state.quotation.errorMessage,
    stepInnerPage: state.steps.stepInnerPage,
    
    carYear: state.vehicles.carYear,
    carModel: state.vehicles.carModel,
    carBrand: state.vehicles.carBrand,
    carUsageArea: state.vehicles.carUsageArea,

    // SelectedAnswer utiliza las listas de marcas y modelos
    // para obtener los nombres a partir del codigo
    carModels: state.vehicles.carModels,
    carBrands: state.vehicles.carBrands,

    hasAssistance: state.vehicles.hasAssistance,
    economic: state.vehicles.economic,
    quoteId: state.quotation.quoteId,
    quoter: state.options.quoter,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    getQuotation: () => {
      dispatch(vehicles.getQuotation(true, false));
    },
    sendQuoteByEmail: (quoter) => {
      dispatch(client.sendQuoteByEmail(quoter));
    },
    onVehiclesValueChange: (type, value) => {
      dispatch(setVehiclesValue(type, value));
      dispatch(setOptionalQuotationValue(!value));
    },
    goBackAuto: (cleanValue) => {
      dispatch(goBackAuto(cleanValue));
      dispatch(decreaseStepByOne());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotation);